export default __webpack_public_path__ + "static/media/property_612.278b3781.png";